export default __webpack_public_path__ + "static/media/gallery_00.adbda2b2.jpg";